// import React, { useState, useEffect } from 'react' 
import { MiFooter } from '../../components/footer/MiFooter';
import Header from '../../components/headers/Header';
import { UsuarioContext } from '../../contexts/UsuarioContext';
import { useContext, useState } from 'react';
import { MenuLateralAB } from "../../components/menuLateralAA/MenuLateralAB";
import ContentMiClub from "../../components/clubCuidatia/ContentMiClub";


const MiClub = (props) => {

    const [MenuLateral, setMenuLateral] = useContext(UsuarioContext)
    const [MenuLateralAux, setMenuLateralAux] = useState();

    const closeMenu = () => {
        if (MenuLateral === true) {
          setMenuLateral(false)
        }
    
      }

    const chageMenuLateralAux = () => {
        setMenuLateralAux(!MenuLateralAux)
    };

    return (
        <div>
            {/* <MenuLateralAB seleccionado={13} MenuLateralAux={MenuLateralAux} chageMenuLateralAux={chageMenuLateralAux} /> */}
            {/* <div onClick={closeMenu} Id="Market">
            {
                OverleyModal === "false" && <Modal
                cerrarPrivacidad={cerrarPrivacidad}
                />
            }
            </div> */}
            <div className='headerCalendario'>
                <Header chageMenuLateralAux={chageMenuLateralAux}/>
            </div>

            <div>
                <ContentMiClub MenuLateralAux={MenuLateralAux} chageMenuLateralAux={chageMenuLateralAux} />
            </div>
            <MiFooter/>
        </div>
    )
}

export default MiClub;